import GlobalAxios from "../axios/axios-config";
import { IOrientations, IOrientationsParams } from "../models/orientations";

const ORIENTATIONS_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v2/tasy/MyAppointment/Orientations";

const MY_SCHEDULES_PORTAL_ORIENTATIONS_ROUTE =
  process.env.REACT_APP_CALENDAR +
  "/api/v2/tasy/MyAppointment/MySchedulesPortal/Orientations";

export const getOrientations = (params: IOrientationsParams) => {
  return GlobalAxios.get<IOrientations>(ORIENTATIONS_ROUTE, { params });
};

export const getMySchedulesPortalOrientations = (
  params: IOrientationsParams,
) => {
  return GlobalAxios.get<IOrientations>(MY_SCHEDULES_PORTAL_ORIENTATIONS_ROUTE, {
    params,
  });
};
